import { baseApi } from "./baseApi";
import { buildPaginationQueryString } from "./queryHelpers";
import { AdminDto, PaginateQuery } from "../../interfaces";

export const adminApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAdminUsers: builder.query<any, PaginateQuery>({
      query: (data) => ({
        url: buildPaginationQueryString(data, `/api/user/admin`),
      }),
      providesTags: ["Paginated-Admins"],
    }),
    getAdminUser: builder.query<AdminDto, string>({
      query: (id) => ({
        url: `/api/user/admin/${id}`,
      }),
      providesTags: ["Admin"],
    }),
    addAdminUser: builder.mutation<any, any>({
      query: (data) => ({
        url: "/api/user/admin",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Paginated-Admins"],
    }),
    updateAdminUser: builder.mutation<
      any,
      { id: string; data: any }
    >({
      query: ({ id, data }) => ({
        url: `/api/user/admin/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Paginated-Admins", "Admin"],
    }),
    deleteAdminUser: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/user/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Paginated-Admins"],
    }),
  }),
});

export const {
  useGetAdminUsersQuery,
  useGetAdminUserQuery,
  useAddAdminUserMutation,
  useUpdateAdminUserMutation,
  useDeleteAdminUserMutation,
} = adminApi;
